import { render, staticRenderFns } from "./NavigationDrawerItems.vue?vue&type=template&id=6b9f6157&scoped=true"
import script from "./NavigationDrawerItems.vue?vue&type=script&lang=js"
export * from "./NavigationDrawerItems.vue?vue&type=script&lang=js"
import style0 from "./NavigationDrawerItems.vue?vue&type=style&index=0&id=6b9f6157&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b9f6157",
  null
  
)

export default component.exports